import { AnytimeFilesPage } from "@/features/anytime/pages/AnytimeFiles";
import React from "react";

const AnytimeFiles = () => {
  return <AnytimeFilesPage />;
};

export default AnytimeFiles;
